import React from 'react';
import { AlertTriangle, Clock, Newspaper, Users } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import TimerTab from './TimerTab';
import './TraineeView.mobile.css';

interface TraineeViewProps {
  roundData: any;
  roundId: string;
}

const TraineeView: React.FC<TraineeViewProps> = ({ roundData }) => {
  // Function to safely render motion data
  const renderMotion = (motion: any) => {
    if (!motion) return 'No motion available';
    if (typeof motion === 'object' && motion !== null) {
      return motion.text || 'No motion text available';
    }
    return motion;
  };

  return (
    <div className="trainee-content trainee-mobile-content">
      {/* User role info */}
      <div className="p-4 border-2 border-purple-500 bg-purple-900 bg-opacity-10 rounded-lg">
        <h3 className="font-semibold mb-2">Trainee Adjudicator</h3>
        <p className="text-sm">
          As a Trainee, you can observe the adjudication process but cannot submit ratings or scores.
        </p>
      </div>

      {/* Round information display */}
      <div className="p-4 rounded-lg" style={{ backgroundColor: 'var(--card-bg)' }}>
        <h3 className="text-lg font-medium mb-4">Round Information</h3>
        <div className="space-y-2">
          <p><span className="font-medium">Motion:</span> {renderMotion(roundData.motion)}</p>
          <p><span className="font-medium">Format:</span> {roundData.format === 'BP' ? 'British Parliamentary' : 'Asian Parliamentary'}</p>
          {roundData.info_slide && (
            <div>
              <p className="font-medium">Info Slide:</p>
              <p className="p-3 rounded-lg mt-1 text-sm" style={{ backgroundColor: 'var(--secondary-bg)' }}>{roundData.info_slide}</p>
            </div>
          )}
        </div>
      </div>

      {/* Trainee notice */}
      <div className="p-4 bg-yellow-500 bg-opacity-10 border border-yellow-500 rounded-lg">
        <div className="flex items-center">
          <AlertTriangle size={18} className="text-yellow-500 mr-2" />
          <p className="text-sm">As a trainee, you can only observe the adjudication process.</p>
        </div>
      </div>

      {/* Adjudication Panel */}
      <div className="p-4 rounded-lg" style={{ backgroundColor: 'var(--card-bg)' }}>
        <h3 className="text-lg font-medium mb-4">Adjudication Panel</h3>
        <div className="space-y-2">
          {roundData.participants
            .filter((p: any) => p.role === 'Chair Adjudicator' || p.role === 'Panelist')
            .map((adjudicator: any) => (
              <div key={adjudicator.id} className={`p-3 border rounded-lg ${
                adjudicator.role === 'Chair Adjudicator' 
                  ? 'border-purple-500 bg-purple-50 dark:bg-purple-900 dark:bg-opacity-10' 
                  : 'border-gray-300 dark:border-gray-600'
              }`}>
                <p className="font-medium">{adjudicator.user.username}</p>
                <p className="text-xs text-gray-500">{adjudicator.role}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default TraineeView;